(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lux-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  const root   = document.getElementById('FragsLuxRoot');
  const nav    = document.getElementById('FragsNav');
  const burger = document.getElementById('FragsBurger');
  const drawer = document.getElementById('FragsDrawer');
  if(!nav) return;

  /* Oculta header Dawn nativo si existiera */
  try{
    const headerGroup = document.querySelector('.shopify-section-group-header-group');
    if(headerGroup){
      headerGroup.querySelectorAll('.shopify-section.section-header').forEach(sec=>{
        if(!sec.contains(root) && (sec.querySelector('header.header') || sec.querySelector('.header__heading-logo-wrapper'))){
          sec.style.display='none';
        }
      });
    }
  }catch(e){}

  function getAnnHeight(){
    const cands = [
      document.getElementById('shopify-section-announcement-bar'),
      document.querySelector('.announcement-bar'),
      document.querySelector('[data-section-type="announcement-bar"]')
    ].filter(Boolean);
    let h = 0; cands.forEach(el=>{ h = Math.max(h, Math.round(el.getBoundingClientRect().height||0)); });
    return h;
  }
  function setVars(){
    document.documentElement.style.setProperty('--frags-ann', getAnnHeight()+'px');
    const h = Math.round(nav.getBoundingClientRect().height||72);
    document.documentElement.style.setProperty('--frags-nav', h+'px');
  }
  setVars();
  window.addEventListener('resize', setVars);

  function onScroll(){ nav.classList.toggle('scrolled', window.scrollY > 80); }
  onScroll();
  window.addEventListener('scroll', onScroll, { passive:true });

  /* Drawer mobile */
  const open = ()=>{ drawer.removeAttribute('hidden'); root.classList.add('nav-open'); burger.setAttribute('aria-expanded','true'); document.documentElement.style.overflow='hidden'; };
  const close= ()=>{ root.classList.remove('nav-open'); burger.setAttribute('aria-expanded','false'); document.documentElement.style.overflow=''; setTimeout(()=>drawer.setAttribute('hidden',''), 200); };
  burger.addEventListener('click', ()=> drawer.hasAttribute('hidden') ? open() : close());
  drawer.querySelector('.frags-drawer__close')?.addEventListener('click', close);
  drawer.querySelector('.frags-drawer__overlay')?.addEventListener('click', close);
  drawer.querySelectorAll('.frags-drawer__link').forEach(a=>a.addEventListener('click', close));

  /* “Puente” ancho = ancho real del panel (desktop) */
  function syncDDWidth(){
    document.querySelectorAll('.frags-has-dd').forEach(li=>{
      const panel = li.querySelector('.frags-dd');
      if(panel){ li.style.setProperty('--ddw', (panel.getBoundingClientRect().width + 20) + 'px'); }
    });
  }
  syncDDWidth();
  window.addEventListener('resize', syncDDWidth);

  /* Acordeones mobile */
  function setupAccordions(){
    document.querySelectorAll('.frags-acc-item').forEach(item=>{
      const btn = item.querySelector('.frags-acc');
      const panel = item.querySelector('.frags-acc__panel');
      if(!btn || !panel) return;

      panel.style.maxHeight = '0px';
      btn.setAttribute('aria-expanded','false');
      panel.hidden = true;

      btn.addEventListener('click', ()=>{
        const isOpen = btn.getAttribute('aria-expanded') === 'true';

        document.querySelectorAll('.frags-acc').forEach(b=>{
          if(b !== btn){
            b.setAttribute('aria-expanded','false');
            const p = b.closest('.frags-acc-item')?.querySelector('.frags-acc__panel');
            if(p){ p.style.maxHeight = '0px'; p.hidden = true; }
          }
        });

        if(isOpen){
          btn.setAttribute('aria-expanded','false');
          panel.style.maxHeight = '0px';
          panel.hidden = true;
        }else{
          btn.setAttribute('aria-expanded','true');
          panel.hidden = false;
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });

    window.addEventListener('resize', ()=>{
      document.querySelectorAll('.frags-acc').forEach(btn=>{
        const panel = btn.closest('.frags-acc-item')?.querySelector('.frags-acc__panel');
        if(panel && btn.getAttribute('aria-expanded') === 'true'){
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  }
  setupAccordions();

  const mo = new MutationObserver(()=>{ setVars(); syncDDWidth(); });
  mo.observe(document.documentElement, {childList:true, subtree:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selector"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const root = document.getElementById('frags-selector-{{ section.id }}');
    if(!root) return;
    const tabs = root.querySelectorAll('.frags-tab');
    tabs.forEach(btn=>{
      btn.addEventListener('click', ()=>{
        const target = btn.getAttribute('data-target');
        tabs.forEach(b=>b.setAttribute('aria-selected', (b===btn) ? 'true' : 'false'));
        root.querySelectorAll('[role="tabpanel"]').forEach(p=>{ p.hidden = (p.id !== target); });
      });
    });
  })();
  
  } catch(e) { console.error(e); }
})();
})();
